import {get, requestJsonp} from "../request";
import * as Sentry from '@sentry/browser';
import store from '../../scripts/store';
import axios from "axios";

export const dynamicApi = {};

let isTest = '';
if (sessionStorage.igEnv == 'development') {
    isTest = 'test_';
}

/**
 * @param params.query_type {number}  查询类型
 * @param params.display_status {number}  查询指定状态
 * @param params.page {number}  页码
 * @param params.page_size {number}  每页请求条数
 * @param params.userid {string}  被查询用户的openid
 * @return {Promise<any>}
 */
dynamicApi.getList = (params) => {
    let {userid = '', page = 1, pageSize = 10, query_type = 1, display_status = 4} = params;
    return new Promise((resolve, reject) => {
        get({
            url: "/gingame/ugc/query_user_moment_list",
            params: {userid, page, page_size: pageSize, query_type, display_status}
        })
            .then(res => resolve(res))
            .catch(err => reject(err))
    })
};

/**
 * 获取动态列表-最热
 * @param params
 * @return {Promise<any>}
 */
dynamicApi.getMomentList = (params) => {
    return new Promise((resolve, reject) => {
        get({
            url: "/gingame/ugc/query_moment_list",
            params: params
        })
            .then(res => {
                let list = res && Array.isArray(res.infolist) ? res.infolist : [];
                dynamicApi.queryAttentionAndCommitNums(list)
                    .then(list => {
                        resolve(list);
                    })
            })
            .catch(err => {
                if (process.env.NODE_ENV == 'production' && sessionStorage.igEnv != 'development') {
                    Sentry.captureException(err)
                }
                reject(err);
            })
    })
};

/**
 * 获取推荐-最新动态（置顶数据）
 * @return {Promise<any>}
 */
dynamicApi.getTopMomentList = () => {
    return new Promise((resolve, reject) => {
        get({
            url: "/gingame/ugc/query_top_moment_list",
            params: {}
        })
            .then(res => {
                let list = res && Array.isArray(res.infolist) ? res.infolist : [];
                dynamicApi.queryAttentionAndCommitNums(list)
                    .then(list => {
                        let mList = list || [];
                        if (mList.length > 1 && mList[1] !== null) {
                            mList.splice(1, 0, null); //内容合辑在第二条
                        }
                        if (mList.length > 4 && mList[4] !== null) {
                            mList.splice(4, 0, null); //话题在第五条
                        }
                        if (mList.length > 7 && mList[7] !== null) {
                            mList.splice(7, 0, null); //用户排行在第八条
                        }
                        resolve(mList);
                    })
            })
            .catch(err => {
                if (process.env.NODE_ENV == 'production' && sessionStorage.igEnv != 'development') {
                    Sentry.captureException(err)
                }
                reject(err);
            })
    })
};

/**
 * 获取推荐-最新动态（不包含置顶）
 * @param params
 * @return {Promise<any>}
 */
dynamicApi.getLatestMomentList = (params) => {
    return new Promise((resolve, reject) => {
        get({
            url: "/gingame/ugc/query_new_moment_list",
            params: params
        })
            .then(res => {
                let list = res && Array.isArray(res.infolist) ? res.infolist : [];
                dynamicApi.queryAttentionAndCommitNums(list)
                    .then(list => {
                        let mList = list || [];
                        if (mList.length > 1 && mList[1] !== null) {
                            mList.splice(1, 0, null); //内容合辑在第二条
                        }
                        if (mList.length > 4 && mList[4] !== null) {
                            mList.splice(4, 0, null); //话题在第五条
                        }
                        if (mList.length > 7 && mList[7] !== null) {
                            mList.splice(7, 0, null); //用户排行在第八条
                        }
                        resolve({
                            list: mList,
                            next_page_time: res.next_page_time
                        });
                    })
            })
            .catch(err => {
                if (process.env.NODE_ENV == 'production' && sessionStorage.igEnv != 'development') {
                    Sentry.captureException(err)
                }
                reject(err);
            })
    })
};


/**
 * 获取用户是否关注和获取评论数量
 * @param list
 * @return {Promise<any>}
 */
dynamicApi.queryAttentionAndCommitNums = (list) => {
    let userId = [];
    for (let i = 0; i < list.length; i++) {
        if (userId.toString().indexOf(list[i]) === -1) {
            userId.push(list[i].openid);
        }
    }
    return new Promise((resolve, reject) => {
        requestJsonp({
            url: '/interactcenter/query_batch_attention_user_info.php',
            data: {
                user_id: userId.join('|'),
                start: 0,
                bid: 'ingame_person'
            }
        }).then(result => {
            if (result.status.toLowerCase() === 'success') {
                const attentions = result.data.attentionlist ? result.data.attentionlist : [];
                for (let i = 0; i < list.length; i++) {
                    for (let x = 0; x < attentions.length; x++) {
                        if (list[i].openid === attentions[x].user_id) {
                            list[i].isAttention = attentions[x].is_attention;
                        }
                    }
                }
                if (store.state.global.config.options.comment) {
                    dynamicApi.queryCommentNums(list)
                        .then((commentNums) => {
                            resolve(commentNums);
                        })
                        .catch(() => {
                            resolve(list);
                        });
                } else {
                    resolve(list);
                }
            } else {
                resolve(list);
            }
        }).catch((error) => {
            reject(error);
        })
    })
};

/**
 * 获取评论数量
 * @param list {array}
 * @return {Promise<any>}
 */
dynamicApi.queryCommentNums = (list) => {
    const params = list.map((item) => {
        const date = new Date(item.publish_time * 1000);
        return `all_mobile,${date.getFullYear() + (date.getMonth() + 1).toString().padStart(2, '0')},${item.aid}_ingame`
    });
    return new Promise((resolve, reject) => {
        requestJsonp({
            url: '/comment/query_source_list_info.php',
            data: {
                busikey: 'all_mobile',
                objlist: params.join(';')
            }
        }).then(result => {
            if (result.status.toLowerCase() === 'success') {
                const commentNums = result.data.stat_list ? result.data.stat_list : [];
                for (let i = 0; i < list.length; i++) {
                    for (let x = 0; x < commentNums.length; x++) {
                        if (list[i] && list[i].aid === commentNums[x].objid.split('_')[0]) {
                            list[i].igNum = {comment: commentNums[x].num};
                            break
                        }
                    }
                }
                resolve(list);
            }
        }).catch((error) => {
            reject(error);
        })
    })
};


/**
 * 判断是否是昨天
 * @param theTime {number} 待比较的时间戳
 * @return {boolean}
 */
function isYesterday(theTime) {
    let date = (new Date());    //当前时间
    let today = new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime(); //今天凌晨
    return theTime < today;
}


/**
 * 前端控制拍脸图
 * @return {Promise<any>}
 */
dynamicApi.getFaceImg = () => {
    const gameId = store.state.global.game;
    return new Promise((resolve, reject) => {
        axios.get('//tiem-cdn.qq.com/sy/' + gameId + '/ingame/moment/' + isTest + 'tips.json')
            .then(res => {
                if (res.status === 200) {
                    let data = res.data || [], arr = [];
                    const faceImg = JSON.parse(localStorage.faceImg || '{}');
                    const now = new Date().getTime();

                    // 判断最后进入的时间
                    if (!faceImg.lastJoinTime) { //为空是今天
                        faceImg.lastJoinTime = new Date().getTime();
                    } else {
                        if (isYesterday(faceImg.lastJoinTime)) { //是昨天则清空数据
                            for (let key in faceImg.m) {
                                faceImg.m[key].daily = 0;
                            }
                        }
                    }
                    faceImg.lastJoinTime = new Date().getTime(); //更新最后进入时间

                    for (let i = 0; i < data.length; i++) {
                        if (data[i].end_time > now && data[i].start_time < now) { //判断是否过期
                            if (data[i].has_limit === 1) { //has_limit为1时daily_times和total字段才会生效
                                if (!faceImg.m || !faceImg.m[data[i].id]) {
                                    faceImg.m = faceImg.m || new Map();
                                    faceImg.m[data[i].id] = {
                                        daily: 0,
                                        total: 0,
                                    };
                                    arr.push(data[i]);
                                } else if (data[i].total > faceImg.m[data[i].id].total && faceImg.m[data[i].id].daily < data[i].daily_times) {
                                    //判断已显示次数是否大于总数 并且 今天显示的次数是否达到上限
                                    arr.push(data[i]);
                                }
                            } else {
                                arr.push(data[i]);
                            }
                        }
                    }
                    localStorage.setItem('faceImg', JSON.stringify(faceImg));

                    resolve(arr);
                } else {
                    reject('获取拍脸图失败');
                }
            })
            .catch(error => {
                reject('获取拍脸图失败' + error.message)
            });
    });
};

/**
 * 后端控制拍脸图
 * @return {Promise<any>}
 */
dynamicApi.getSplashScreenList = () => {
    return new Promise((resolve, reject) => {
        get({
            url: '/gingame/push/splash_screen_list', params: {}
        }).then(data => {
            let {splash_screen_list = []} = data;
            resolve(splash_screen_list);
        }).catch(error => {
            reject(error);
        })
    })
};

/**
 * 后端控制拍脸图-上报
 * @param id {number} 拍脸图id
 * @param type {number} 上报类型 1浏览  2点击
 * @return {Promise<any>}
 */
dynamicApi.splashScreenReport = (id, type) => {
    return new Promise((resolve, reject) => {
        get({
            url: '/gingame/push/splash_screen_report', params: {
                id,
                behavior_type: type,
            }
        }).then(data => {
            resolve(data);
        }).catch(error => {
            reject(error);
        })
    })
};

/**
 * 系统消息列表
 * @param params.last_read_id {number} 翻页时、上一页的最后一个消息的ID
 * @param params.limit {number} 页面大小 默认为10
 * @param params.page {number} 页码 默认为1
 * @return {Promise<any>}
 */
dynamicApi.getSysMsgList = (params) => {
    let {last_read_id = 0, page = 1,isReaded = 1} = params;
    return new Promise((resolve, reject) => {
        get({
            url: '/gingame/push/sys_msg_list', params: {
                last_read_id, //翻页时、上一页的最后一个消息的ID
                limit: 6, //页面大小 默认为10
                is_read: isReaded, //拉取数据后是否标识该消息已读1标识已读，0标识未读
                page, //页码     默认为1
            }
        }).then(data => {
            let {last_read_id = 0, max_read_id = 0, msg_feed_list = []} = data;
            resolve({
                msg_feed_list,
                last_read_id, //用于翻页、获取下一页时传回
                max_read_id, //已读的消息的最大ID 可以根据这个ID判断是否为未读消息
            });
        }).catch(error => {
            reject(error);
        })
    })
};

/**
 * 上报系统消息浏览、点击数据
 * @param params.ids {string} 系统消息id 多个id以','分割
 * @param params.behavior_type {number} 上报类型 1 浏览  2 点击
 * @return {Promise<any>}
 */
dynamicApi.sysMsgReport = (params) => {
    let {behavior_type = 0, ids} = params;
    return new Promise((resolve, reject) => {
        get({
            url: '/gingame/push/sys_msg_report', params: {
                ids,
                behavior_type,
            }
        }).then(data => {
            resolve(data);
        }).catch(error => {
            resolve(error);
        })
    })
};

/**
 * 获取热门话题
 * @return {Promise<any>}
 */
dynamicApi.getHotTopic = () => {
    const gameId = store.state.global.game;
    return new Promise((resolve, reject) => {
        // 获取静态资源
        axios.get('https://tiem-cdn.qq.com/sy/' + gameId + '/ingame/moment/' + isTest + 'index.json')
            .then(res => {
                if (res.status === 200) {
                    const topics = res.data.hot_topics || [];
                    resolve(topics.splice(0, 3))
                } else {
                    reject('获取热门话题失败！')
                }
            })
            .catch(error => {
                // reject('获取热门话题失败' + error.message)
            });
    })
};
